"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropoffAnalyticsElement = void 0;
const MetaElement_1 = require("./MetaElement");
class DropoffAnalyticsElement extends MetaElement_1.MetaElement {
    constructor(options) {
        super(options);
    }
    get dropoffTextDiv() {
        if (!this.shadowRoot) {
            return;
        }
        return this.shadowRoot.querySelector('.dropofftext');
    }
    get dropoffValueDiv() {
        if (!this.shadowRoot) {
            return;
        }
        return this.shadowRoot.querySelector('.dropoffvalue');
    }
    get dropoffPercentDiv() {
        if (!this.shadowRoot) {
            return;
        }
        return this.shadowRoot.querySelector('.dropoffpercent');
    }
}
exports.DropoffAnalyticsElement = DropoffAnalyticsElement;
